module.exports = __webpack_public_path__ + "media/dashboard/assets/images/window-minimize-34732e7d6cedb80254abd096d475fb70.svg";